import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsDataCards } from "../widgets";
import manageImagePlaceholders from "../utils/placeholder-images";
import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";

export const initClient = () => loadClientWidgets(widgetsDataCards);

initClient();
manageImagePlaceholders();

document.addEventListener('DOMContentLoaded', () => {});
